import { useSyncExternalStore } from 'react';
import { mockStore, type MockTables } from '@/lib/mock-store';

export function useMockTable<K extends keyof MockTables>(table: K): MockTables[K] {
  return useSyncExternalStore(
    (cb) => mockStore.subscribe(cb),
    () => mockStore.getAll(table),
    () => mockStore.getAll(table),
  );
}
